import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { TemplateFourResumeSection } from "./common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";

export const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateFourResumeSection themeColor={themeColor} heading={heading}>
      <View wrap={false}>{summary && <ResumePDFText>{summary}</ResumePDFText>}</View>
    </TemplateFourResumeSection>
  );
};
